import { useEffect } from 'react';
import useFCM from '../../hooks/useFCM';

const FCMManager = () => {
  const { activate } = useFCM();

  useEffect(() => {
    activate();
  }, [activate]);

  return null;
};

export default FCMManager;
